import { useAuth0 } from '@auth0/auth0-react';
import { useQuery } from '@tanstack/react-query';
import { getGeneralExcelNumberPreview } from '../../../api/carteleriaApi';

const useGetGenerateExcelNumberPreview = (params) => {
  const { getAccessTokenSilently } = useAuth0();
  return useQuery({
    queryKey: ['generate-excel-number-preview', params],
    queryFn: async () => {
      const token = await getAccessTokenSilently();
      return await getGeneralExcelNumberPreview(token, params);
    },
  });
};

export default useGetGenerateExcelNumberPreview;
